import React from 'react';
import PropertyAlgolia from "./PropertyAlgolia";
import DescCut from "./DescCut";
import { isNotEmpty } from "../../util/user";
import algoliasearch from "algoliasearch";
import {Link} from 'react-router-dom';
import loading from '../../images/loading.png';
// import header from '../../images/header.jpg';
import header_two_ham from '../../images/header_two_ham.jpg';
import header from '../../images/header.jpg';


export default class CustomPage extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    let listing = this.props.customPage;

    let firstImage = undefined

    if (listing !== undefined) {
      var elem = document.createElement('div');
      elem.style.display = 'none';
      document.body.appendChild(elem);
      elem.innerHTML = listing.body;
      firstImage = elem.querySelector('img')
    }

    if (!isNotEmpty(firstImage)) {
      firstImage = "https://besthamiltonhouses.com/static/media/logo.df977010.png"
    } else {
      firstImage = firstImage.src
    }

    return (
      <Link to={"/posts/"+listing.slug}>
        <img src={firstImage} />

        <div className="property-info">
          <h2>{listing.title}</h2>
        </div>

        {listing &&
          <div className="desc">
            <DescCut
              truncate={true}
              id={listing.id}
              description={listing.body}/>
          </div>
        }
      </Link>
    )
  }
};
